module.exports = __webpack_public_path__ + "img/finishBanner.3b675236.png";